const allCountries = [
        ["Afghanistan (‫افغانستان‬‎)", "AF", "93", "+93-##-###-####"],
        ["Albania (Shqipëri)", "AL", "355", "+355(###)###-###"],
        ["Algeria (‫الجزائر‬‎)", "DZ", "213", "+213-##-###-####"],
        ["American Samoa", "AS", "1684", "+1(684)###-####"],
        ["Andorra", "AD", "376", "+376-###-#####"],
        ["Angola", "AO", "244", "+244(###)###-###"],
        ["Anguilla", "AI", "1264", "+1(264)###-####"],
        ["Antigua and Barbuda", "AG", "1268", "+1(268)###-####"],
        ["Argentina", "AR", "54", "+54(###)###-####"],
        ["Armenia (Հայաստան)", "AM", "374", "+374-##-###-###"],
        ["Aruba", "AW", "297", "+297-###-#####"],
        ["Australia", "AU", "61", "+61-#-####-####"],
        ["Austria (Österreich)", "AT", "43", "+43(###)###-#####"],
        ["Azerbaijan (Azərbaycan)", "AZ", "994", "+994-##-###-##-##"],
        ["Bahamas", "BS", "1242", "+1(242)###-####"],
        ["Bahrain (‫البحرين‬‎)", "BH", "973", "+973-####-####"],
        ["Bangladesh (বাংলাদেশ)", "BD", "880", "+880-##-###-###"],
        ["Barbados", "BB", "1246", "+1(246)###-####"],
        ["Belarus (Беларусь)", "BY", "375", "+375(##)###-##-##"],
        ["Belgium (België)", "BE", "32", "+32(###)###-###"],
        ["Belize", "BZ", "501", "+501-###-#####"],
        ["Benin (Bénin)", "BJ", "229", "+229-##-##-####"],
        ["Bermuda", "BM", "1441", "+1(441)###-####"],
        ["Bhutan (འབྲུག)", "BT", "975", "+975-#-###-####"],
        ["Bolivia", "BO", "591", "+591-#-###-####"],
        ["Bosnia and Herzegovina (Босна и Херцеговина)", "BA", "387", "+387-##-######"],
        ["Botswana", "BW", "267", "+267-##-###-###"],
        ["Brazil (Brasil)", "BR", "55", "+55(##)9####-####"],
        ["British Indian Ocean Territory", "IO", "246", "+246-###-#####"],
        ["British Virgin Islands", "VG", "1284", "+1(284)###-####"],
        ["Brunei", "BN", "673", "+673-###-#####"],
        ["Bulgaria (България)", "BG", "359", "+359(###)###-###"],
        ["Burkina Faso", "BF", "226", "+226-##-##-####"],
        ["Burundi (Uburundi)", "BI", "257", "+257-##-##-####"],
        ["Cambodia (កម្ពុជា)", "KH", "855", "+855-##-###-###"],
        ["Cameroon (Cameroun)", "CM", "237", "+237-####-####"],
        ["Canada", "CA", "1", "+1(###)###-####"],
        ["Cape Verde (Kabu Verdi)", "CV", "238", "+238(###)##-###"],
        ["Caribbean Netherlands", "BQ", "599", "+599-###-######"],
        ["Cayman Islands", "KY", "1345", "+1(345)###-####"],
        ["Central African Republic (République centrafricaine)", "CF", "236", "+236-##-##-####"],
        ["Chad (Tchad)", "TD", "235", "+235-##-##-##-##"],
        ["Chile", "CL", "56", "+56-#-####-####"],
        ["China (中国)", "CN", "86", "+86-##-#####-#####"],
        ["Christmas Island", "CX", "61", "+61-###-#######"],
        ["Cocos (Keeling) Islands", "CC", "61", "+61-###-#######"],
        ["Colombia", "CO", "57", "+57(###)###-####"],
        ["Comoros (‫جزر القمر‬‎)", "KM", "269", "+269-##-######"],
        ["Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)", "CD", "243", "+243(###)###-###"],
        ["Congo (Republic) (Congo-Brazzaville)", "CG", "242", "+242-##-###-####"],
        ["Cook Islands", "CK", "682", "+682-##-######"],
        ["Costa Rica", "CR", "506", "+506-####-####"],
        ["Côte d’Ivoire", "CI", "225", "+225-##-###-###"],
        ["Croatia (Hrvatska)", "HR", "385", "+385-##-###-###"],
        ["Cuba", "CU", "53", "+53-#-###-#####"],
        ["Curaçao", "CW", "599", "+599-###-#####"],
        ["Cyprus (Κύπρος)", "CY", "357", "+357-##-###-###"],
        ["Czech Republic (Česká republika)", "CZ", "420", "+420(###)###-###"],
        ["Denmark (Danmark)", "DK", "45", "+45-##-##-##-###"],
        ["Djibouti", "DJ", "253", "+253-##-##-##-##"],
        ["Dominica", "DM", "1767", "+1(767)###-####"],
        ["Dominican Republic (República Dominicana)", "DO", "1", "+1(849)###-####"],
        ["Ecuador", "EC", "593", "+593-#-###-####"],
        ["Egypt (‫مصر‬‎)", "EG", "20", "+20(###)###-####"],
        ["El Salvador", "SV", "503", "+503-##-##-####"],
        ["Equatorial Guinea (Guinea Ecuatorial)", "GQ", "240", "+240-##-###-####"],
        ["Eritrea", "ER", "291", "+291-#-###-####"],
        ["Estonia (Eesti)", "EE", "372", "+372-###-#####"],
        ["Ethiopia", "ET", "251", "+251-##-###-####"],
        ["Falkland Islands (Islas Malvinas)", "FK", "500", "+500-########"],
        ["Faroe Islands (Føroyar)", "FO", "298", "+298-###-#####"],
        ["Fiji", "FJ", "679", "+679-##-######"],
        ["Finland (Suomi)", "FI", "358", "+358(###)###-##-##"],
        ["France", "FR", "33", "+590(###)###-###"],
        ["French Guiana (Guyane française)", "GF", "594", "+594-#####-####"],
        ["French Polynesia (Polynésie française)", "PF", "689", "+689-##-##-####"],
        ["Gabon", "GA", "241", "+241-#-##-##-###"],
        ["Gambia", "GM", "220", "+220(###)##-###"],
        ["Georgia (საქართველო)", "GE", "995", "+995(###)###-###"],
        ["Germany (Deutschland)", "DE", "49", "+49-###-########"],
        ["Ghana (Gaana)", "GH", "233", "+233(###)###-###"],
        ["Gibraltar", "GI", "350", "+350-###-#####"],
        ["Greece (Ελλάδα)", "GR", "30", "+30(###)###-####"],
        ["Greenland (Kalaallit Nunaat)", "GL", "299", "+299-##-##-####"],
        ["Grenada", "GD", "1473", "+1(473)###-####"],
        ["Guadeloupe", "GP", "590", "+590-###-######"],
        ["Guam", "GU", "1671", "+1(671)###-####"],
        ["Guatemala", "GT", "502", "+502-#-###-####"],
        ["Guernsey", "GG", "44", "+44-###-#######"],
        ["Guinea (Guinée)", "GN", "224", "+224-##-###-###"],
        ["Guinea-Bissau (Guiné Bissau)", "GW", "245", "+245-#-#######"],
        ["Guyana", "GY", "592", "+592-###-#####"],
        ["Haiti", "HT", "509", "+509-##-##-####"],
        ["Honduras", "HN", "504", "+504-####-####"],
        ["Hong Kong (香港)", "HK", "852", "+852-####-####"],
        ["Hungary (Magyarország)", "HU", "36", "+36(###)###-###"],
        ["Iceland (Ísland)", "IS", "354", "+354-###-#####"],
        ["India (भारत)", "IN", "91", "+91(####)###-###"],
        ["Indonesia", "ID", "62", "+62(8##)###-##-###"],
        ["Iran (‫ایران‬‎)", "IR", "98", "+98(###)###-####"],
        ["Iraq (‫العراق‬‎)", "IQ", "964", "+964(###)###-####"],
        ["Ireland", "IE", "353", "+353(###)###-###"],
        ["Isle of Man", "IM", "44", "+44-###-#######"],
        ["Israel (‫ישראל‬‎)", "IL", "972", "+972-##-###-####"],
        ["Italy (Italia)", "IT", "39", "+39(###)####-###"],
        ["Jamaica", "JM", "1876", "+1(876)###-####"],
        ["Japan (日本)", "JP", "81", "+81(###)###-###"],
        ["Jersey", "JE", "44", "+44-###-#######"],
        ["Jordan (‫الأردن‬‎)", "JO", "962", "+962-#-####-####"],
        ["Kazakhstan (Казахстан)", "KZ", "77", "+7(7##)###-##-##"],
        ["Kenya", "KE", "254", "+254-###-######"],
        ["Kiribati", "KI", "686", "+686-##-######"],
        ["Kosovo", "XK", "383", "+383-###-######"],
        ["Kuwait (‫الكويت‬‎)", "KW", "965", "+965-####-####"],
        ["Kyrgyzstan (Кыргызстан)", "KG", "996", "+996(###)###-###"],
        ["Laos (ລາວ)", "LA", "856", "+856-##-###-###"],
        ["Latvia (Latvija)", "LV", "371", "+371-##-###-###"],
        ["Lebanon (‫لبنان‬‎)", "LB", "961", "+961-#-###-####"],
        ["Lesotho", "LS", "266", "+266-#-###-####"],
        ["Liberia", "LR", "231", "+231-##-###-###"],
        ["Libya (‫ليبيا‬‎)", "LY", "218", "+218-21-###-####"],
        ["Liechtenstein", "LI", "423", "+423(###)###-####"],
        ["Lithuania (Lietuva)", "LT", "370", "+370(###)##-###"],
        ["Luxembourg", "LU", "352", "+352(###)###-###"],
        ["Macau (澳門)", "MO", "853", "+853-####-####"],
        ["Macedonia (FYROM) (Македонија)", "MK", "389", "+389-##-###-###"],
        ["Madagascar (Madagasikara)", "MG", "261", "+261-##-##-#####"],
        ["Malawi", "MW", "265", "+265-#-####-####"],
        ["Malaysia", "MY", "60", "+60-#-###-#####"],
        ["Maldives", "MV", "960", "+960-###-#####"],
        ["Mali", "ML", "223", "+223-##-##-####"],
        ["Malta", "MT", "356", "+356-####-####"],
        ["Marshall Islands", "MH", "692", "+692-###-#####"],
        ["Martinique", "MQ", "596", "+596(###)##-##-##"],
        ["Mauritania (‫موريتانيا‬‎)", "MR", "222", "+222-##-##-####"],
        ["Mauritius (Moris)", "MU", "230", "+230-###-#####"],
        ["Mayotte", "YT", "262", "+262-###-######"],
        ["Mexico (México)", "MX", "52", "+52-##-##-#####"],
        ["Micronesia", "FM", "691", "+691-###-#####"],
        ["Moldova (Republica Moldova)", "MD", "373", "+373-Z###-####"],
        ["Monaco", "MC", "377", "+377-##-###-###"],
        ["Mongolia (Монгол)", "MN", "976", "+976-##-##-####"],
        ["Montenegro (Crna Gora)", "ME", "382", "+382-##-###-###"],
        ["Montserrat", "MS", "1664", "+1(664)###-####"],
        ["Morocco (‫المغرب‬‎)", "MA", "212", "+212-##-####-###"],
        ["Mozambique (Moçambique)", "MZ", "258", "+258-##-###-###"],
        ["Myanmar (Burma) (မြန်မာ)", "MM", "95", "+95-###-######"],
        ["Namibia (Namibië)", "NA", "264", "+264-##-###-####"],
        ["Nauru", "NR", "674", "+674-###-#####"],
        ["Nepal (नेपाल)", "NP", "977", "+977-##-###-###"],
        ["Netherlands (Nederland)", "NL", "31", "+31-##-###-####"],
        ["New Caledonia (Nouvelle-Calédonie)", "NC", "687", "+687-##-######"],
        ["New Zealand", "NZ", "64", "+64(###)###-####"],
        ["Nicaragua", "NI", "505", "+505-####-####"],
        ["Niger (Nijar)", "NE", "227", "+227-##-##-####"],
        ["Nigeria", "NG", "234", "+234(###)###-####"],
        ["Niue", "NU", "683", "+683-########"],
        ["Norfolk Island", "NF", "672", "+672-3##-#####"],
        ["North Korea (조선 민주주의 인민 공화국)", "KP", "850", "+850-####-#############"],
        ["Northern Mariana Islands", "MP", "1670", "+1(670)###-####"],
        ["Norway (Norge)", "NO", "47", "+47(###)##-####"],
        ["Oman (‫عُمان‬‎)", "OM", "968", "+968-##-###-###"],
        ["Pakistan (‫پاکستان‬‎)", "PK", "92", "+92(###)###-####"],
        ["Palau", "PW", "680", "+680-###-#####"],
        ["Palestine (‫فلسطين‬‎)", "PS", "970", "+970-##-###-####"],
        ["Panama (Panamá)", "PA", "507", "+507-###-#####"],
        ["Papua New Guinea", "PG", "675", "+675(###)##-###"],
        ["Paraguay", "PY", "595", "+595(###)###-###"],
        ["Peru (Perú)", "PE", "51", "+51(###)###-###"],
        ["Philippines", "PH", "63", "+63(###)###-####"],
        ["Poland (Polska)", "PL", "48", "+48(###)###-###"],
        ["Portugal", "PT", "351", "+351-##-###-####"],
        ["Puerto Rico", "PR", "1", "+1-###-#########"],
        ["Qatar (‫قطر‬‎)", "QA", "974", "+974-####-####"],
        ["Réunion (La Réunion)", "RE", "262", "+262-#####-####"],
        ["Romania (România)", "RO", "40", "+40-##-###-####"],
        ["Russia (Россия)", "RU", "7", "+7(R##)###-##-##"],
        ["Rwanda", "RW", "250", "+250(###)###-###"],
        ["Saint Barthélemy", "BL", "590", "+590-###-######"],
        ["Saint Helena", "SH", "290", "+290-########"],
        ["Saint Kitts and Nevis", "KN", "1869", "+1(869)###-####"],
        ["Saint Lucia", "LC", "1758", "+1(758)###-####"],
        ["Saint Martin (Saint-Martin (partie française))", "MF", "590", "+590-###-######"],
        ["Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "PM", "508", "+508-###-######"],
        ["Saint Vincent and the Grenadines", "VC", "1784", "+1(784)###-####"],
        ["Samoa", "WS", "685", "+685-##-######"],
        ["San Marino", "SM", "378", "+378-####-######"],
        ["São Tomé and Príncipe (São Tomé e Príncipe)", "ST", "239", "+239-##-######"],
        ["Saudi Arabia (‫المملكة العربية السعودية‬‎)", "SA", "966", "+966-#-###-####"],
        ["Senegal (Sénégal)", "SN", "221", "+221-##-###-####"],
        ["Serbia (Србија)", "RS", "381", "+381-##-###-####"],
        ["Seychelles", "SC", "248", "+248-#-###-####"],
        ["Sierra Leone", "SL", "232", "+232-##-######"],
        ["Singapore", "SG", "65", "+65-####-#####"],
        ["Sint Maarten", "SX", "1721", "+1(721)###-####"],
        ["Slovakia (Slovensko)", "SK", "421", "+421(###)###-###"],
        ["Slovenia (Slovenija)", "SI", "386", "+386-##-###-###"],
        ["Solomon Islands", "SB", "677", "+677-########"],
        ["Somalia (Soomaaliya)", "SO", "252", "+252-#-###-####"],
        ["South Africa", "ZA", "27", "+27-##-###-####"],
        ["South Korea (대한민국)", "KR", "82", "+82-##-###-#####"],
        ["South Sudan (‫جنوب السودان‬‎)", "SS", "211", "+211-##-###-####"],
        ["Spain (España)", "ES", "34", "+34(###)###-###"],
        ["Sri Lanka (ශ්‍රී ලංකාව)", "LK", "94", "+94-##-###-####"],
        ["Sudan (‫السودان‬‎)", "SD", "249", "+249-##-###-####"],
        ["Suriname", "SR", "597", "+597-###-#####"],
        ["Svalbard and Jan Mayen", "SJ", "47", "+47-####-######"],
        ["Swaziland", "SZ", "268", "+268-##-##-####"],
        ["Sweden (Sverige)", "SE", "46", "+46-##-###-####"],
        ["Switzerland (Schweiz)", "CH", "41", "+41-##-###-####"],
        ["Syria (‫سوريا‬‎)", "SY", "963", "+963-##-####-###"],
        ["Taiwan (台灣)", "TW", "886", "+886-####-####"],
        ["Tajikistan", "TJ", "992", "+992-##-###-####"],
        ["Tanzania", "TZ", "255", "+255-##-###-####"],
        ["Thailand (ไทย)", "TH", "66", "+66-##-###-####"],
        ["Timor-Leste", "TL", "670", "+670-78#-#####"],
        ["Togo", "TG", "228", "+228-##-###-###"],
        ["Tokelau", "TK", "690", "+690-########"],
        ["Tonga", "TO", "676", "+676-########"],
        ["Trinidad and Tobago", "TT", "1868", "+1(868)###-####"],
        ["Tunisia (‫تونس‬‎)", "TN", "216", "+216-##-###-###"],
        ["Turkey (Türkiye)", "TR", "90", "+90(###)###-####"],
        ["Turkmenistan", "TM", "993", "+993-#-###-####"],
        ["Turks and Caicos Islands", "TC", "1649", "+1(649)###-####"],
        ["Tuvalu", "TV", "688", "+688-2#######"],
        ["U.S. Virgin Islands", "VI", "1340", "+1(340)###-####"],
        ["Uganda", "UG", "256", "+256(###)###-###"],
        ["Ukraine (Україна)", "UA", "380", "+380(##)###-##-##"],
        ["United Arab Emirates (‫الإمارات العربية المتحدة‬‎)", "AE", "971", "+971-#-###-#####"],
        ["United Kingdom", "GB", "44", "+44-####-#######"],
        ["United States", "US", "1", "+1(###)###-####"],
        ["Uruguay", "UY", "598", "+598-#-###-##-##"],
        ["Uzbekistan (Oʻzbekiston)", "UZ", "998", "+998-##-###-####"],
        ["Vanuatu", "VU", "678", "+678-########"],
        ["Vatican City (Città del Vaticano)", "VA", "39", "+39-6-698-#####"],
        ["Venezuela", "VE", "58", "+58(###)###-####"],
        ["Vietnam (Việt Nam)", "VN", "84", "+84(###)####-###"],
        ["Wallis and Futuna (Wallis-et-Futuna)", "WF", "681", "+681-##-######"],
        ["Western Sahara (‫الصحراء الغربية‬‎)", "EH", "212", "+212-###-######"],
        ["Yemen (‫اليمن‬‎)", "YE", "967", "+967-##-###-###"],
        ["Zambia", "ZM", "260", "+260-##-###-####"],
        ["Zimbabwe", "ZW", "263", "+263-#-#######"],
        ["Åland Islands", "AX", "358", "+358-###-######"]
    ];
export const countriesIso = allCountries.map(country => country[1].toUpperCase());

export const countries: PhoneCodeCountry[] = allCountries.map(country => ({
    name: country[0],
    iso2: country[1].toUpperCase(),
    dialCode: country[2],
    mask: country[3]
}));

export interface PhoneCodeCountry {
    name: string,
    iso2: string,
    dialCode: string,
    mask: string
}
